import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const forceScrolled = pathname.startsWith('/articles/');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isScrolled = forceScrolled || scrolled;

  const navLinks = [
    { label: 'ニュースレター', href: '#reports' },
    { label: '記事一覧', href: '#articles' },
    { label: 'お問い合わせ', href: '#contact' },
    { label: '入会案内', href: '#join' },
  ];

  const scrollTo = (href: string) => {
    setMenuOpen(false);
    const id = href.replace('#', '');
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass border-b border-gray-200/50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 h-16 lg:h-20">
        {/* ロゴ + タイトル */}
        <div
          className="flex items-center space-x-2 flex-shrink-0 cursor-pointer"
          onClick={() => forceScrolled ? navigate('/') : window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img src="/ebc-portal-icon.png" alt="Logo" className="h-8 w-8 md:h-10 md:w-10 object-contain flex-shrink-0" />
          <span className={`text-sm sm:text-base md:text-xl font-bold tracking-tight truncate max-w-[160px] sm:max-w-xs md:max-w-none transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
            民族文化生物学研究会
          </span>
        </div>
        {/* デスクトップナビ */}
        <nav className="hidden md:flex flex-1 justify-center space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors hover:text-[#4a7c59] ${isScrolled ? 'text-gray-700' : 'text-white'}`}
              onClick={e => { e.preventDefault(); scrollTo(link.href); }}
            >
              {link.label}
            </a>
          ))}
        </nav>
        {/* ハンバーガー */}
        <div className="flex items-center flex-shrink-0 ml-2">
          <button
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 gap-1.5"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`block w-5 h-0.5 transition-all duration-200 origin-center ${isScrolled ? 'bg-gray-700' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-5 h-0.5 transition-all duration-200 ${isScrolled ? 'bg-gray-700' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-5 h-0.5 transition-all duration-200 origin-center ${isScrolled ? 'bg-gray-700' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </div>
      {/* モバイルドロップダウンメニュー */}
      {menuOpen && (
        <nav className="md:hidden glass border-t border-gray-100">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="block px-6 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#4a7c59] font-medium border-b border-gray-100 transition"
              onClick={e => { e.preventDefault(); scrollTo(link.href); }}
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
